// import anime from 'animejs'
// import BB_Cart from './cart';

export default class SP_Header {
    constructor() {
        SP_Header.init()
    }
    static init() {

        SP_Header.cart = jQuery('.ob-cart-btn-wrap')
        SP_Header.cart_loader = SP_Header.cart.find('.ob-loader')
        SP_Header.cart_count = SP_Header.cart.find('.ob-cart-count')

        // jQuery('.ob-prod-img-wrap').on('mouseenter', Header.img_hover)
        // jQuery('.ob-prod-img-wrap').on('mouseleave', BB_Archive_Product.img_leave)

        // jQuery('.ob-quick-cart-btn').on('click', BB_Archive_Product.quick_cart)
        // jQuery('.ob-quick-cart-close-btn').on('click', BB_Archive_Product.quick_cart_close)
        // // jQuery('.ob-select-wrap select').on('change', BB_Archive_Product.quick_cart_select)
        // jQuery('.ob-add-to-cart-btn').on('click', BB_Archive_Product.add_to_cart)

    }
    static cart_start_loading() {
        setTimeout(() => {
            SP_Header.cart_count.addClass('ob-inactive')
        }, 100)

        SP_Header.cart_loader.removeClass('ob-inactive')
    }
    static cart_end_loading() {
        setTimeout(() => {
            SP_Header.cart_count.removeClass('ob-inactive')
        }, 100)

        SP_Header.cart_loader.addClass('ob-inactive')

    }
    static cart_item_count( count ) {
        if ( count ) {
            SP_Header.cart_count.html(count)
        }
    }
    // static quick_cart_select() {
    //     let $this = jQuery(this);

    //     console.dir($this.val())


    //     // BB_Cart.sidebar_open()
    // }
    static cart_icon_refresh() {

    }

}

